import axios from "axios";
// import { setAlert } from './alert';
import { GET_PURCHASES, PURCHASE_ERROR } from "./types";

// Get user's purchases
export const getPurchases = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/purchase`);

    dispatch({
      type: GET_PURCHASES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PURCHASE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
